export enum Languages {
  English = 'en',
  Swedish = 'sv',
  SwedishSE = 'sv-SE',
  Danish = 'da',
  German = 'de',
  Spanish = 'es',
  French = 'fr',
  Norwegian = 'no',
  Portuguese = 'pt',
  Ukrainian = 'uk'
}